import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { FileSaverService } from '../../../shared/services/output/file-saver.service';
import { DocumentUploadData, DocumentUploadModalComponent } from '../../../shared/components/document/document-upload-modal.component';
import { DocumentItemKeyData } from '../../../shared/models/document/document-itemkey.model';
import { RequiredDocumentDetailsModel } from '../../../shared/models/document/required-document-details.model';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { DocumentItemKeyType } from '../../../shared/enums/document-item-key-type.enum';
import { DocumentService } from '../../../shared/services/document/document.service';
import { ModalSize } from '../../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { DocumentSearchResult } from '../../../shared/models/document/document-search-result.model';

export class DocumentSelectModalContext {
    constructor(
        public customerNumberId: number,
        public documentCategoryTypeId: number,
        public documentTypeId: number
    ) {}
}

@Component({
    selector: 'document-select',
    templateUrl: './document-select-modal.html'
})
export class DocumentSelectModalComponent extends BaseComponent {
    public customerDocuments: DocumentSearchResult[];

    constructor(
        public dialogRef: MatDialogRef<DocumentSelectModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DocumentSelectModalContext,
        public modalService: MvdModalService,
        private documentService: DocumentService,
        private fileSaverService: FileSaverService
    ) {
        super();
    }

    public ngOnInit() {
        this.loadDocuments();
    }

    public downloadDocument = (documentId: number): void => {
        this.documentService.getDocument(documentId).subscribe(r => {
            this.fileSaverService.saveBase64ToFile(r.documentFilename, r.documentContent, r.documentMimeTypeValue);
        });
    };

    public selectDocument = (document: DocumentSearchResult): void => {
        this.dialogRef.close(document);
    };

    public cancel = (): void => {
        this.dialogRef.close();
    };

    public launchDocumentsModal = (): void => {
        let documentSearchItems: DocumentItemKeyData[] = [];
        let requiredDocumentDetails = new Array<RequiredDocumentDetailsModel>();

        // customer
        let documentSearchItemCustomer: DocumentItemKeyData = new DocumentItemKeyData();
        documentSearchItemCustomer.documentItemKeyTypeId = 1;
        documentSearchItemCustomer.itemKeyId = this.data.customerNumberId;
        documentSearchItems.push(documentSearchItemCustomer);

        let r1 = new RequiredDocumentDetailsModel();
        r1.documentCategoryTypeId = 21;
        requiredDocumentDetails.push(r1);

        let data = new DocumentUploadData(documentSearchItems, [], requiredDocumentDetails);
        // open the modal
        this.modalService.open(DocumentUploadModalComponent, data, ModalSize.Medium)
            .afterClosed()
            .subscribe(() => this.loadDocuments(), err => this.handleValidationResult(err));
    };

    private loadDocuments = (): void => {
        let searchData = {
            documentItemKeyTypeId: DocumentItemKeyType.Customer,
            itemKeyId: this.data.customerNumberId,
            documentCategoryTypeId: this.data.documentCategoryTypeId,
            documentTypeId: this.data.documentTypeId
        };
        this.documentService.retrieveDocumentMetadata(searchData)
            .subscribe(r => this.customerDocuments = r.result);
    };
}
